import { useEffect, useRef } from "react";

import { useAuthState } from "@/auth/AuthProvider";
import { authPlaybackSessionChanged } from "@/playback/authPlaybackSession";

/**
 * Playback state belongs to exactly one authenticated session. Normal route
 * changes may preserve intentional receiver handoffs, but a sign-out or a
 * different sign-in must terminate every playback owner.
 */
export function useTerminatePlaybackOnAuthSessionChange(
  terminatePlayback: () => void
) {
  const { authSessionKey } = useAuthState();
  const previousSessionKeyRef = useRef(authSessionKey);
  const terminatePlaybackRef = useRef(terminatePlayback);
  terminatePlaybackRef.current = terminatePlayback;

  useEffect(() => {
    const previousSessionKey = previousSessionKeyRef.current;
    previousSessionKeyRef.current = authSessionKey;
    if (!authPlaybackSessionChanged(previousSessionKey, authSessionKey)) return;
    terminatePlaybackRef.current();
  }, [authSessionKey]);
}
